import {Component, ElementRef, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {forkJoin, Subject, takeUntil} from "rxjs";
import {SearchState, SearchStateService} from "../_core/services/search-state.service";
import {
  ActionPasser,
  BahamutHelper,
  Checkbox,
  Dropdown,
  ErrorMessages,
  GMList,
  Grandmaster,
  Logger, TabsContainer,
  Validator,
  OverlayService,
  Utils
} from "lo-bahamut";
import {SearchService} from "../_core/services/search.service";
import {SearchV2Service} from "../_core/services/search-v2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {LoadingSpinnerService} from "../_core/services/loading-spinner.service";
import {HandlebarsService} from "../services/handlebars.service";
import {CareFindrTenantConfigurationService} from "../_core/api/services/care-findr-tenant-configuration.service";
import {CareFindrTenantConfigurationService as CareFindrTenantConfigurationServiceV2 } from "../_core/apiV2/services/care-findr-tenant-configuration.service";
import {ProviderSearchService} from "../_core/apiV2/services/provider-search.service";
import {Router} from "@angular/router";
import {CURRENT_TENNANT} from "../app.component";
import {SearchResultService} from "../services/search-result.service";
import {Subscription} from "rxjs";
import * as Handlebars from "handlebars"
import {level} from "lo-bahamut-v1/types";
import {option} from "../search-start-v2/search-start-v2.component";
import {CareFindrConfigApiService} from "../_core/api/services/care-findr-config-api.service";
import {ProviderResponseOfPractitionerRoles} from "../_core/api/models/provider-response-of-practitioner-roles";
import {FacilityResponseOfOrgAffiliations} from "../_core/api/models/facility-response-of-org-affiliations";
import {ProviderResponseOfPractitionerRoles as ProviderResponseOfPractitionerRolesV2} from "../_core/apiV2/models/provider-response-of-practitioner-roles";
import {FacilityResponseOfOrgAffiliations as FacilityResponseOfOrgAffiliationsV2} from "../_core/apiV2/models/facility-response-of-org-affiliations";
import {BasicProviderSearchQuery} from "../_core/apiV2/models/basic-provider-search-query";
import {BasicProviderSearchQuery as BasicProviderSearchQueryV2} from "../_core/apiV2/models/basic-provider-search-query";
import {isNull, omitBy} from "lodash-es";
import {BasicOrganizationSearchQuery} from "../_core/apiV2/models/basic-organization-search-query";
import {BasicOrganizationSearchQuery as BasicOrganizationSearchQueryV2} from "../_core/apiV2/models/basic-organization-search-query";
// import {SearchCardData,SearchResultCardAdapterService} from "../_core/services/searchResultCard/search-result-card-adapter.service";
import {
  AggregateRootOfPractitionerPractitionerRole,
  AggregateRootOfFacilityOrganizationAffiliation,
  FacilityResponseOfMasteredLocations,
  ProviderResponseOfMasteredLocations, OrganizationAffiliationsGroupedByLocation, PractitionerRolesGroupedByLocation,
} from 'src/app/_core/api/models';

import {
  AggregateRootOfPractitionerPractitionerRole as AggregateRootOfPractitionerPractitionerRoleV2,
  AggregateRootOfFacilityOrganizationAffiliation as AggregateRootOfFacilityOrganizationAffiliationV2,
  FacilityResponseOfMasteredLocations as FacilityResponseOfMasteredLocationsV2,
  ProviderResponseOfMasteredLocations as ProviderResponseOfMasteredLocationsV2,
  OrganizationAffiliationsGroupedByLocation as OrganizationAffiliationsGroupedByLocationV2,
  PractitionerRolesGroupedByLocation as PractitionerRolesGroupedByLocationV2,
} from 'src/app/_core/apiV2/models';
// import {
//   SearchResultCardExpandInformationData, SearchResultCardExpandTab1AdapterService
// } from "../_core/services/searchResultCard/search-result-card-expand-tab1-adapter.service";
// import {processedTelecom, SearchResultCardExpandTab2Service} from "../_core/services/searchResultCard/search-result-card-expand-tab2.service";
import {processedTelecom, SearchResultCardExpandTab2V2Service } from "../_core/services/searchResultCardV2/search-result-card-expand-tab2-v2.service";
import {PrintPdfService} from "../_core/services/print-pdf.service";
import {
  SearchResultCardAdapterV2Service, SearchCardData
} from "../_core/services/searchResultCardV2/search-result-card-adapter-v2.service";
import {
  SearchResultCardExpandTab1AdapterV2Service, SearchResultCardExpandInformationData
} from "../_core/services/searchResultCardV2/search-result-card-expand-tab1-adapter-v2.service";
import {Title} from "@angular/platform-browser"
import {PrintPdfV2Service} from "../_core/services/print-pdf-v2.service";
import { BuildWatcher, FilterSync } from "lo-bahamut";
import {
  applyPcpSpecialtySelection as applyPcpSpecialtySelectionToDropdown,
  getActiveVisibleEnabledRef,
  getRefsByJsonId,
  hideFilterPill,
} from "../_core/services/pcp-specialty-utils";

@Component({
  selector: 'app-nls-search-result-v2',
  templateUrl: './nls-search-result-v2.component.html',
  styleUrls: ['./nls-search-result-v2.component.scss']
})
export class NlsSearchResultV2Component  implements  OnInit, OnDestroy{
  private url: string = "../../assets/nls-search-result-page.hbs";
  // private url: string = "../../assets/search-result-page-mddoh.hbs";
  private _data: any;
  private templateResponse: any;
  isPlanDropDownEnabled = true;
  isNLSearchEnabled = false;
  isSpecialityHeaderNeedToChange = false;
  isClearingFilters: boolean = false;
  destroyed$ = new Subject<void>();
  private previousScrollTop: number = 0;
  planOptions: option[] = [];
  specialtyOptions: level[] = [];
  genderOptions: option[] = [];
  languageOptions: option[] = [];

  searchState: SearchState = {
    Query: {
      sortBy: 'distance-asc',
    },
    Extra: {},
  };

  printState: SearchState = {
    Query: {},
    Extra: {},
  };

  printProviderReady: boolean = false;
  printFacilityReady: boolean = false;
  imgPaths: string[] = [];
  currentTab!: string;

  providerSearchResults: ProviderResponseOfPractitionerRolesV2 = {};
  facilitySearchResults: FacilityResponseOfOrgAffiliationsV2 = {};
  providerFilterSearchResults: ProviderResponseOfPractitionerRolesV2 = {};
  facilityFilterSearchResults: FacilityResponseOfOrgAffiliationsV2 = {};
  providerPrintResults: ProviderResponseOfPractitionerRoles = {};
  facilityPrintResults: FacilityResponseOfOrgAffiliations = {};
// result card
  providerCardDataArray: any ;
  facilityCardDataArray: any ;

  itemsPerPageProvider: number = 10;
  currentPageProvider: number = 1;

  itemsPerPageFacility: number = 10;
  currentPageFacility: number = 1;
  isLoading: boolean = false;


  private searchResultData!: Subscription;

  // elements UK variables
  languageDropdownUK: any;
  genderDropdownUK: any;
  anpCheckboxUK: any;
  acceptingDropdownUK: any;
  handicapCheckboxUK: any;
  pcpCheckboxUK: any;
  languagePillUK: any;
  genderPillUK: any;
  anpPillUk: any;
  acceptingPillUK: any
  handicapPillUK: any;
  pcpPillUk: any;

  // detail call
  detailCallSubscription: Subscription;
  providerDetailsData!: ProviderResponseOfMasteredLocationsV2;
  facilityDetailsData!: FacilityResponseOfMasteredLocationsV2
  isExpanded: boolean = false;
  providerInfoData: SearchResultCardExpandInformationData;
  facilityInfoData: SearchResultCardExpandInformationData;
  locationData: {
    telecomData: processedTelecom;
    root: OrganizationAffiliationsGroupedByLocationV2 | PractitionerRolesGroupedByLocationV2
  }[];
  relationsGroupedByLocation!:
    | OrganizationAffiliationsGroupedByLocationV2[]
    | PractitionerRolesGroupedByLocationV2[];

  // result tab json varibale
  resultsTabsJSON: any;

  printProviderResultBtnUk: any;
  printFacilityResultBtnUk: any;
  filterBlockUk: any;
  tabChange: TabsContainer;

  showMoreDetailsData!:
    | FacilityResponseOfMasteredLocations
    | ProviderResponseOfMasteredLocations;

  facilityTabUk: any;
  providerTabUk: any;

  private lastFocusedElement: HTMLElement | null = null;

  // page title
  defaultTitle: string = '';

  // nls variables
  nlSearchQuery: string | undefined = '';
  initialSearchResponse: any | undefined;

  tenantConfig$: any;
  tenantComponentJs$: any;

  isInitialSearh: boolean = true;
  aiSearchText: string | undefined;

  prevQueryState: any;



  public get data(): any { return this._data; }
  @ViewChild('gm') gm: Grandmaster;

  constructor(private searchService: SearchService,
              private searchV2Service: SearchV2Service,
              public actionPasser: ActionPasser,
              public gmList: GMList,
              private loadingSpinnerService: LoadingSpinnerService,
              public logger: Logger,
              private lobhelper: BahamutHelper,
              public errorMessages: ErrorMessages,
              public grandmaster: Grandmaster,
              public validator: Validator,
              private hbs: HandlebarsService,
              private searchStateService: SearchStateService,
              private configApiService: CareFindrConfigApiService,
              private tenantConfigService: CareFindrTenantConfigurationService,
              private tenantConfigServiceV2: CareFindrTenantConfigurationServiceV2,
              private providerSearchService: ProviderSearchService,
              private router: Router,
              private searchResultService: SearchResultService,
              private searchCardAdapter: SearchResultCardAdapterV2Service,
              private searchResultCardExpandTab1AdapterService: SearchResultCardExpandTab1AdapterV2Service,
              private searchResultCardExpandTab2Service: SearchResultCardExpandTab2V2Service,
              private printService: PrintPdfV2Service,
              public overlay: OverlayService,
              public utils: Utils,
              private titleService: Title,
              public buildWatcher: BuildWatcher,
              public filterSync: FilterSync
  ) {
  }

  ngOnInit() {
    this.defaultTitle = this.titleService.getTitle();
    const newTitle = 'CareFinDr: Search Results';
    this.titleService.setTitle(newTitle);
    // Trigger screen reader announcement
    setTimeout(() => {
      const liveRegion = document.getElementById('page-title-announcer');
      if (liveRegion) {
        liveRegion.textContent = newTitle;
      }
    }, 100);

    this.loadingSpinnerService.showLoader();
    // const tenantJSON = this.tenantConfigServiceV2.getTenantComponentBluePrint({page_name: 'result-tab', tenant: CURRENT_TENNANT});

    // forkJoin([tenantJSON])
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe({
    //     next: ([componentJsResponse]) => {
    //       let response: any = {}
    //       if (typeof componentJsResponse === "string") {
    //         response = JSON.parse(componentJsResponse);
    //         console.log("response",response);
    //       } else {
    //         response = componentJsResponse;
    //       }
    //       // this._data = response.componentsConfig;
    //       this.errorMessages.defaultErrorMessages = response.errorMessages;
    //       console.log(this.data);
    //     },
    //     error: (err) => {
    //       if (err.status === 403) {
    //         console.error('You are not authorized to view this', err);
    //         this.router.navigate(['error-handler'], {state: { msg:"Access denied"}});
    //       } else {
    //         console.error('Please try again later or contact support.', err);
    //       }
    //     },
    //     complete: () => {
    //       this.loadingSpinnerService.hideLoader();
    //     }
    //   });


    this.searchStateService.searchState$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((state) => {
        this.searchState = state;
      });
    this.searchState = this.searchStateService.getSearchCriteria();
    this.printState = this.searchStateService.getSearchCriteria();

    //TODO: To be revised after configuration driven UI is implemented
    if(CURRENT_TENNANT === 'centerlight' || CURRENT_TENNANT === 'mddoh')
      this.isPlanDropDownEnabled = false;

    if(CURRENT_TENNANT === 'centerlight')
      this.isNLSearchEnabled = true;

    //TODO: To be revised after configuration driven UI is implemented
    if(CURRENT_TENNANT === 'mddoh')
      this.isSpecialityHeaderNeedToChange = true;

    // storing the ai search text from the nl-search query for the future use.
    this.aiSearchText = this.searchState?.Extra?.aiSearch;


    //get existing results and search state passed from search-start
    this.providerSearchResults = this.searchV2Service.getCurrentProviderResults();
    this.facilitySearchResults = this.searchV2Service.getCurrentFacilityResults();
    // }
    if (this.providerSearchResults?.providers) {
      this.providerCardDataArray = {
        providers: this.mapSearchResults<AggregateRootOfPractitionerPractitionerRoleV2>(
          this.providerSearchResults.providers,
          (item) => this.searchCardAdapter.adaptProvider(item)
        )
      };
    }
    if (this.facilitySearchResults?.facilities) {
      this.facilityCardDataArray = {
        facilities: this.mapSearchResults<AggregateRootOfFacilityOrganizationAffiliationV2>(
          this.facilitySearchResults.facilities,
          (item) => this.searchCardAdapter.adaptFacility(item)
        )
      };
    }

    const tenantConfig$ = this.configApiService.getCareFindrTenantConfig({tenant: CURRENT_TENNANT});
    const tenantComponentJs$ = this.tenantConfigService.getTenantComponentJs({tenant: CURRENT_TENNANT});

    forkJoin([tenantConfig$, tenantComponentJs$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: ([configResponse, componentJsResponse]: any) => {
          this.planOptions = configResponse.planDropdown?.options as option[];

          this.specialtyOptions = componentJsResponse.specialtyDropdown?.options?.map((option: any) => {
            return {
              value: option.value as string,
              description: option.description as string,
              children: option.children?.sort((a: any,b: any) => {
                return a.description!.localeCompare(b.description!);
              }) as level[]
            };
          }).sort((a: any, b: any) => {
            return a.description!.localeCompare(b.description!);
          }) as level[];
          this.planOptions = componentJsResponse.planDropdown?.options as option[] || [];
          this.genderOptions = componentJsResponse.genderDropdown?.options as option[];
          this.languageOptions = componentJsResponse.languageDropdown?.options as option[];
          this.getCareLoaDrJson();
        },
        error: (err) => {
          if (err.status === 403) {
            console.error('You are not authorized to view this', err);
            this.router.navigate(['error-handler'], {state: { msg:"Access denied"}});
          } else {
            console.error('Please try again later or contact support.', err);
          }
        },
        complete: () => {
          this.loadingSpinnerService.hideLoader();
        }
      });

    this.searchService.providerPrintResults$
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((results) => {
        this.providerPrintResults = {...results};

        if(this.providerPrintResults.providers && (this.providerPrintResults.providers!.length > 0 || this.providerPrintResults.total == 0)) {
          this.printProviderReady = true;
        }
      });
    this.searchService.facilityPrintResults$
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((results) => {
        this.facilityPrintResults = {...results};

        if(this.facilityPrintResults.facilities && (this.facilityPrintResults.facilities!.length > 0 || this.facilityPrintResults.total == 0)) {
          this.printFacilityReady = true;
        }
      });

    // const tenantComponentJs$ = this.tenantConfigService.getTenantComponentBluePrint({
    //   page_name: 'patient-search',
    //   tenant: CURRENT_TENNANT
    // });
    this.buildPreface();

    this.actionPasser.groupEmitter$.pipe(takeUntil(this.destroyed$)).subscribe((group: any) => {
      // console.log(group)
      if (group !== undefined && Object.keys(group).length !== 0) {
        switch (group[0].groupName) {
          // find the first non-disabled (0/empty) tab and focus it
          case "focusResultsTab":
            this.focusResultsTab(group);
            break;

          //search-required groups
          case "updateDistanceDropdown":
            this.updateDistanceDropdown(group);
            break;
          case "updateDistanceSlider":
            this.updateDistanceSlider(group);
            break;

          //search-filter groups
          case "selectedLanguage":
            if(!this.isInitialSearh){
              this.selectedLanguage(group);
            }
            break;
          case "selectedGender":
            if(!this.isInitialSearh) {
              this.selectedGender(group);
            }
            break;
          case "checkedAccepting":
            if(!this.isInitialSearh) {
              this.checkedAccepting(group);
            }
            break;
          case "acceptingDropdownUpdate":
            if(!this.isInitialSearh) {
              this.acceptingDropdownUpdate(group);
            }
            break;
          case "checkedHandicap":
            if(!this.isInitialSearh) {
              this.checkedHandicap(group);
            }
            break;
          case "checkedPCP":
            if(!this.isInitialSearh) {
              this.checkedPCP(group);
            }
            break;
          case "resetFilterLanguage":
            this.resetFilterLanguage(group);
            break;
          case "resetFilterGender":
            this.resetFilterGender(group);
            break;
          case "resetANPCheckbox":
            this.resetANPCheckbox(group);
            break;
          case "resetFilterAccepting":
            this.resetFilterAccepting(group);
            break;
          case "resetHandicapCheckbox":
            this.resetHandicapCheckbox(group);
            break;
          case "resetPCPCheckbox":
            this.resetPCPCheckbox(group);
            break;
          case "clearFilters":
            this.clearFilters(group);
            break;
          case "showMoreProviderDetails":
            this.toggleProviderFacilityDetailsWithAnimation(group, "Provider");
            break;
          case "showMoreFacilityDetails":
            this.toggleProviderFacilityDetailsWithAnimation(group, "Facility");
            break;
          case "show-more-details": {
            var showMoreButtonElem = this.gmList.gmList[group[0].uniqueKey].elementRef;
            var detailsTabsRef = this.gmList.gmList[group[1].uniqueKey].reference;
            var printButtonRef = this.gmList.gmList[group[2].uniqueKey].reference;
            var result = showMoreButtonElem?.closest(".result");
            if (detailsTabsRef.hide === false){
              result?.classList.add("details-open");
              printButtonRef.hide = false;
            }
            else {
              result?.classList.remove("details-open");
              printButtonRef.hide = true;
            }
            break;
          }
          case "handleInputChange":
            if(!this.isInitialSearh) {
              this.handleInputChange(group);
            }else{
              console.log("initial search is not done yet");
            }
            break;
          case "printResults":
            if(this.printProviderReady || this.printFacilityReady) {
              this.printResults(group);
            }
            break;
          case "resultTabSwitch":
            this.currentTab = this.gmList.gmList[group[0].uniqueKey].reference.label;
            break;
          // show/hide filters and sidebar on edit click when in 'mobile' view
          case "edit-search-criteria":
            var filtersElem = this.gmList.gmList[group[1].uniqueKey].elementRef;
            var sidebarElem = this.gmList.gmList[group[2].uniqueKey].elementRef;
            var breadcrumbsElem = this.gmList.gmList[group[3].uniqueKey].elementRef;
            if (filtersElem?.classList.contains("show")){
              filtersElem?.classList.remove("show");
              sidebarElem?.classList.remove("show");
              sidebarElem?.removeAttribute("style");
            }
            else {
              filtersElem?.classList.add("show");
              sidebarElem?.classList.add("show");
              var totalMoveDown = breadcrumbsElem?.offsetHeight! + filtersElem?.offsetHeight!;
              sidebarElem?.setAttribute("style", "height: calc(100dvh - "+totalMoveDown+"px)");
            }
            break;
          case "printDetailProvider":
            this.printDetailProvider(group);
            break;
          case "printDetailFacility":
            this.printDetailFacility(group);
            break;
          case "pagination":
            this.pagination(group);
            break;
          case "handleNlsInput":
            this.handleNlsInput(group);
            break;
          case "nlSearchSubmit":
            this.nlSearchSubmit(group);
            break;
          case "nlsClearInput":
            this.nlsClearInput(group);
            break;


          // Below are the groups for the sidebar collapse
          case "collapse-sidebar": {
            var sidebarEl = this.gmList.gmList[group[1].uniqueKey].elementRef;
            var sidebarCollapsedEl = this.gmList.gmList[group[2].uniqueKey].elementRef;
            var mainEl = this.gmList.gmList[group[3].uniqueKey].elementRef;
            sidebarEl?.classList.add("hidden");
            sidebarCollapsedEl?.classList.remove("hidden");
            mainEl?.classList.add("expanded");
            break;
          }
          case "expand-sidebar": {
            var sidebarCollapsedEl = this.gmList.gmList[group[2].uniqueKey].elementRef;
            var sidebarEl = this.gmList.gmList[group[1].uniqueKey].elementRef;
            var mainEl = this.gmList.gmList[group[3].uniqueKey].elementRef;
            sidebarCollapsedEl?.classList.add("hidden");
            sidebarEl?.classList.remove("hidden");
            mainEl?.classList.remove("expanded");
            break;
          }
          case "sidebar-open-filter": {
            this.utils.delay(1000);
            var filterEl = this.gmList.gmList[group[1].uniqueKey].elementRef;
            filterEl?.focus();
            filterEl?.click();
            break;
          }
          case "sidebar-open-input": {
            this.utils.delay(1000);
            var filterEl = this.gmList.gmList[group[1].uniqueKey].elementRef;
            var inputInside = filterEl?.querySelector("input");
            inputInside?.focus();
            break;
          }
          case "sidebar-open-distance": {
            this.utils.delay(1000);
            var filterEl = this.gmList.gmList[group[1].uniqueKey].elementRef;
            filterEl?.focus();
            filterEl?.click();
            break;
          }
          case "sidebar-open-cb": {
            this.utils.delay(1000);
            var filterEl = this.gmList.gmList[group[1].uniqueKey].elementRef;
            filterEl?.focus();
            break;
          }
        }
      }
    });
  }

  private mapSearchResults<T>(
    items: T[] | undefined,
    adapterFn: (item: T) => SearchCardData | undefined
  ): any[] {
    if (!items) return [];

    return items.map((item: T) => {
      const cardData = adapterFn(item);

      return {
        ...cardData,
        formattedName: this.capitalizeEachWord(cardData?.extras?.Name || ''),
        formattedDistance: this.truncateDistance(cardData?.extras?.MinDistance),
        cardDataArray: this.getCardDataArray(cardData),
        acceptingPatients: (item as any).relations?.[0]?.acceptingPatients?.code === 'newpt'
          ? (item as any).relations?.[0]?.acceptingPatients?.display
          : undefined,
        stableId: (item as any).stableId,
        stableIdHash: (item as any).stableIdHash,
        heads: (item as any).heads
      };
    });
  }

  handleNlsInput(group: any) {
  }
  nlsClearInput(group: any) {
    this.gmList.gmList[group[1].uniqueKey].reference.data = "";
  }

  nlSearchSubmit(group: any) {
    this.isInitialSearh = true;
    this.loadingSpinnerService.showLoader();
    this.searchStateService.updateSearchCriteria(this.searchState);
    const queryText = this.gmList.gmList[group[1].uniqueKey].reference.data;
    const requestPayload = {
      query: queryText
    };

    let mainContainerUk = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
    let cfBottomUk = this.lobhelper.getDesiredChildUK(mainContainerUk, "cf_bottom");
    let cfSidebarUk = this.lobhelper.getDesiredChildUK(cfBottomUk, "cf_sidebar");


    let requiredSearchUk = this.lobhelper.getDesiredChildUK(cfSidebarUk, "required_search");

    let planDropdownUk = this.lobhelper.getDesiredChildUK(requiredSearchUk, "plan_dropdown");
    let planDropdownRef: any = undefined;
    if(planDropdownUk){
      planDropdownRef = this.gmList.gmList[planDropdownUk].reference;
    }

    let rsLocationUk = this.lobhelper.getDesiredChildUK(requiredSearchUk, "rs_location");
    let rsLocationRef = this.gmList.gmList[rsLocationUk].reference;

    let rsDistanceContainerUk = this.lobhelper.getDesiredChildUK(requiredSearchUk, "rs_distance");
    let rsDistanceContainerRef = this.gmList.gmList[rsDistanceContainerUk].reference;

    let rsDistanceSliderUk = this.lobhelper.getDesiredChildUK(rsDistanceContainerUk, "rs_distance_slider");
    let rsDistanceSliderRef = this.gmList.gmList[rsDistanceSliderUk].reference;

    let rsProviderUk = this.lobhelper.getDesiredChildUK(requiredSearchUk, "name_input");
    let rsProviderRef = this.gmList.gmList[rsProviderUk].reference;

    let rsSpecialityUk = this.lobhelper.getDesiredChildUK(requiredSearchUk, "provider_or_speciality_dropdown");
    let rsSpecialityRef = this.gmList.gmList[rsSpecialityUk].reference;




    let filtersUk = this.lobhelper.getDesiredChildUK(cfSidebarUk, "filters");

    let filtersLanguageUk = this.lobhelper.getDesiredChildUK(filtersUk, "filters_language");
    let filtersLanguageRef = this.gmList.gmList[filtersLanguageUk].reference;

    let filtersGenderUk = this.lobhelper.getDesiredChildUK(filtersUk, "filters_gender");
    let filtersGenderRef = this.gmList.gmList[filtersGenderUk].reference;

    let filtersAnpUk = this.lobhelper.getDesiredChildUK(filtersUk, "filters_anp");
    let filtersAnpRef = this.gmList.gmList[filtersAnpUk].reference;

    let filtersHaUk = this.lobhelper.getDesiredChildUK(filtersUk, "filters_ha");
    let filtersHaRef = this.gmList.gmList[filtersHaUk].reference;

    let filtersPcpUk = this.lobhelper.getDesiredChildUK(filtersUk, "filters_pcp");
    let filtersPcpRef = this.gmList.gmList[filtersPcpUk].reference;

    this.providerSearchService.naturalLanguageProviderSearchCareFindr({
      'x-tenant-id': CURRENT_TENNANT,
      'x-persona': 'user',
      body: requestPayload
    }).subscribe({
      next: (response: any) => {
        if (response) {
          this.loadingSpinnerService.hideLoader();

          if(response.query.location.message === "LOCATION_NOT_PROVIDED"){
            let outerContainerUk = this.lobhelper.getDesiredChildUK("1", "main_outer_container")
            let errorModelUk = this.lobhelper.getDesiredChildUK(outerContainerUk, "errorModal");
            this.loadingSpinnerService.hideLoader();
            let errorModalRef = this.gmList.gmList[errorModelUk].reference;
            const modalBody = this.gmList.gmList[errorModalRef.children[0]].reference;
            const htmlRef = this.gmList.gmList[modalBody.children[0]].reference;
            htmlRef.code = "Location is missing please search based on the location"
            errorModalRef.hide = false;
            return
          }

          // Clone and preprocess query
          const queryCopy = JSON.parse(JSON.stringify(response?.query));
          const locationText = queryCopy?.location?.text || '';
          if (queryCopy?.location?.text) delete queryCopy.location.text;
          if (queryCopy?.attrs && Object.keys(queryCopy.attrs).length === 0) delete queryCopy.attrs;
          if (!queryCopy.sortBy) queryCopy.sortBy = "distance-asc";

          // Store initial search response (optional)
          this.initialSearchResponse = response;

          // Prepare new search state
          const newSearchState = {
            Query: queryCopy,
            Extra: {
              ...this.searchState.Extra,
              locationText,
              aiSearch: queryText
            }
          };

          // Compare with previous query state
          if (!this.prevQueryState || !this.deepEqual(this.prevQueryState, newSearchState.Query)) {

            // Update state only if something changed
            this.searchState = newSearchState;
            this.searchStateService.updateSearchCriteria(this.searchState);

            // Update refs only if values differ
            if(planDropdownRef){
              this.updateIfChanged(planDropdownRef, 'data', this.searchState.Query.programType);
            }
            this.updateIfChanged(rsLocationRef, 'data', response.query.location?.text ? { formatted_address: response.query.location.text } : undefined);
            this.updateIfChanged(rsDistanceSliderRef, 'data', this.searchState.Query.location?.distance || ["25"]);
            this.updateIfChanged(rsProviderRef, 'data', this.searchState.Query.name);
            this.updateIfChanged(rsSpecialityRef, 'data', response.query.specialtiesV2, "rsSpecialityRef");
            this.updateIfChanged(filtersLanguageRef, 'data', response.query.language);
            this.updateIfChanged(filtersGenderRef, 'data', response.query.gender ? [response.query.gender] : undefined);
            this.updateIfChanged(filtersAnpRef, 'checked', !!this.searchState.Query.isAcceptingNewPatient);
            this.updateIfChanged(filtersHaRef, 'checked', !!this.searchState.Query.isHandicapAccessible);
            this.updateIfChanged(filtersPcpRef, 'checked', !!response.query.isPCP);
            this.updateClearFiltersButtonVisibility();
            // Save current query for next check
            this.prevQueryState = JSON.parse(JSON.stringify(newSearchState.Query));
          }
          setTimeout(() => {
            this.isInitialSearh = false;
            this.isSearchEnabled();})
        }

      },
      error: (err: HttpErrorResponse) => {
        this.logger.error(err);
        console.log(err)
        let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
        let errorModelUk = this.lobhelper.getDesiredChildUK(outerContainerRef, "errorModal");
        this.loadingSpinnerService.hideLoader();
        let errorModalRef = this.gmList.gmList[errorModelUk].reference;
        const modalBody = this.gmList.gmList[errorModalRef.children[0]].reference;
        const htmlRef = this.gmList.gmList[modalBody.children[0]].reference;
        htmlRef.code =
          err.status === 400
            ? err.error?.message
            : err.status === 500
              ? "Something went wrong. Please try again."
              : err.error?.errors?.map((er: { errorMessage: string }) => er.errorMessage).join('<br>');
        errorModalRef.hide = false;
      }
    });

  }

  updateIfChanged(ref: any, prop: string, newValue: any, refText?: string) {
    if(refText == "rsSpecialityRef"){
      ref.cdRef.markForCheck();
      console.log("refText", ref.cdRef.markForCheck())
    }
    const safeValue = this.normalizeValue(newValue);

    if (!this.deepEqual(ref[prop], safeValue)) {
      ref[prop] = safeValue;
    }


  }

  /**
   * Converts null values to undefined or empty arrays/strings depending on type
   */
  normalizeValue(val: any) {
    if (val === null || val === undefined) return undefined;
    if (Array.isArray(val) && val.length === 0) return [];
    return val;
  }

  /**
   * Deep equality check
   */
  deepEqual(obj1: any, obj2: any) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  formatSpecialties(specialtiesV2: any): string {
    return JSON.stringify(specialtiesV2, null, 4); // Formats with newlines and indentation
  }

  /**
   * Wait for the asynchronous HBS-generated DOM to be fully rendered,
   * then execute the given callback once the expected selector is found.
   *
   * @param {string} containerId - The DOM id of the container you inject into.
   * @param {string} selector - A CSS selector for an element that must exist when rendering is 'done'.
   * @param {Function} callback - Code to execute once rendering is complete.
   */
  waitForHbsRender(containerId: string, selector: string, callback: () => void): void {
    const container = document.getElementById(containerId);
    if (!container) return;

    // Quick check: already rendered?
    if (container.querySelector(selector)) {
      callback();
      return;
    }

    const observer = new MutationObserver((_mutations, obs) => {
      if (container.querySelector(selector)) {
        obs.disconnect();
        callback();
      }
    });
    observer.observe(container, { childList: true, subtree: true });
  }


  toggleProviderFacilityDetailsWithAnimation(group: any, currentTab: string) {
    const targetId = group[0]?.id;
    if (!targetId) return;
    let detailsTabsUK = group[1].uniqueKey;
    const contentDiv = document.getElementById(targetId);
    if (!contentDiv) return;

    const isExpanded = contentDiv.classList.contains('expanded');

    let npiID = group[0].passedInfo[0];

    if (isExpanded) {
      contentDiv.style.maxHeight = contentDiv.scrollHeight + 'px';
      requestAnimationFrame(() => {
        contentDiv.style.maxHeight = '0px';
        contentDiv.classList.remove('expanded');
        contentDiv.style.maxHeight = '40px';
        this.previousScrollTop = window.scrollY;
        setTimeout(() => {
          contentDiv.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          });
        }, 500);
        this.loadingSpinnerService.hideLoader();
      });
    } else {
      this.loadingSpinnerService.showLoader();
      if(currentTab == 'Provider'){
        this.detailCallSubscription = this.searchV2Service
          .getProviderDetails(npiID)
          .subscribe(
            (data: ProviderResponseOfMasteredLocationsV2 | undefined) => {
              if (data != undefined) {
                this.showMoreDetailsData = data;
                this.relationsGroupedByLocation = data.providers![0].relations!;
                this.getProcessedData()
                const providerResponse = data;
                if (providerResponse && providerResponse.providers) {
                  const aggregateRootProvider = providerResponse.providers[0];
                  this.providerInfoData = this.searchResultCardExpandTab1AdapterService.adaptProvider(
                    aggregateRootProvider
                  );
                  let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;
                  const previouslyActiveTabUk = detailsTabsRef.getCurrentTabUk?.();
                  const tabToActivate = previouslyActiveTabUk || this.lobhelper.getDesiredChildUK(detailsTabsUK, "tab_location_information");
                  if (tabToActivate && this.gmList.gmList[detailsTabsUK]?.reference?.changeTab) {
                    this.gmList.gmList[detailsTabsUK].reference.changeTab(tabToActivate);
                  }
                }
                // Getting the provider partial and Compiling template response
                // this.searchResultData = this.searchResultService.getSearchResultJson("../../assets/hbs_partials/provider-facility-show-more-partial.hbs").subscribe(response => {
                this.searchResultData = this.tenantConfigServiceV2.getTenantComponentBluePrint({page_name: 'show-more-partial-tab', tenant: CURRENT_TENNANT}).subscribe(response => {
                  if(response.encodedTemplate == null) return;
                  let res = atob(response.encodedTemplate);
                  const template = Handlebars.compile(res);
                  const renderedHtml = template({
                    tabInfo: this.providerInfoData,
                    locationsData: this.locationData,
                    tab: this.currentTab
                  });
                  let data = JSON.parse(renderedHtml);
                  let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;


                  if(detailsTabsRef.children.length > 0) {
                    detailsTabsRef.children.forEach(async (childUk: string) => {
                      var childGm = this.gmList.gmList[childUk];
                      await childGm.reference.clearForDestroy();
                    });
                    detailsTabsRef.children = [];
                    detailsTabsRef.tabs = [];
                    detailsTabsRef.addChildrenToThisView(data);
                  }else{
                    detailsTabsRef.addChildrenToThisView(data);
                  }
                });

                this.isExpanded = !this.isExpanded;
                this.providerDetailsData = data;
              }
              contentDiv.style.overflow = 'hidden';
              contentDiv.classList.add('expanded');
              requestAnimationFrame(() => {
                contentDiv.style.maxHeight = contentDiv.scrollHeight + 'px';
              });

              setTimeout(() => {
                contentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 500);
              this.loadingSpinnerService.hideLoader();
            }
          );
      }else if(currentTab == 'Group/Facility'){
        this.detailCallSubscription = this.searchV2Service
          .getFacilityDetails(npiID)
          .subscribe(
            (data: FacilityResponseOfMasteredLocationsV2 | undefined) => {
              if (data != undefined) {
                this.showMoreDetailsData = data;
                this.relationsGroupedByLocation = data.facilities![0].relations!;
                this.getProcessedData()
                const facilityResponse = data;
                if (facilityResponse && facilityResponse.facilities) {
                  const aggregateRootFacility = facilityResponse.facilities[0];
                  this.facilityInfoData = this.searchResultCardExpandTab1AdapterService.adaptFacility(
                    aggregateRootFacility
                  );

                  let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;
                  const previouslyActiveTabUk = detailsTabsRef.getCurrentTabUk?.();
                  const tabToActivate = previouslyActiveTabUk || this.lobhelper.getDesiredChildUK(detailsTabsUK, "tab_location_information");
                  if (tabToActivate && this.gmList.gmList[detailsTabsUK]?.reference?.changeTab) {
                    this.gmList.gmList[detailsTabsUK].reference.changeTab(tabToActivate);
                  }
                }
                // Getting the provider partial and Compiling template response
                // this.searchResultData = this.searchResultService.getSearchResultJson("../../assets/hbs_partials/provider-facility-show-more-partial.hbs").subscribe(response => {
                this.searchResultData = this.tenantConfigServiceV2.getTenantComponentBluePrint({page_name: 'show-more-partial-tab', tenant: CURRENT_TENNANT}).subscribe(response => {
                  if(response.encodedTemplate == null) return;
                  let res = atob(response.encodedTemplate);
                  const template = Handlebars.compile(res);
                  const renderedHtml = template({
                    tabInfo: this.facilityInfoData,
                    locationsData: this.locationData,
                    tab: this.currentTab
                  });
                  let data = JSON.parse(renderedHtml as string);
                  let detailsTabsRef = this.gmList.gmList[detailsTabsUK].reference;

                  if(detailsTabsRef.children.length > 0){
                    detailsTabsRef.children.forEach(async (childUk: string) => {
                      var childGm = this.gmList.gmList[childUk];
                      await childGm.reference.clearForDestroy();
                    });
                    detailsTabsRef.children = [];
                    detailsTabsRef.tabs = [];
                    detailsTabsRef.addChildrenToThisView(data);
                  }else{
                    detailsTabsRef.addChildrenToThisView(data);
                  }
                });


                this.isExpanded = !this.isExpanded;
                this.facilityDetailsData = data;
              }
              contentDiv.style.overflow = 'hidden';
              contentDiv.classList.add('expanded');
              requestAnimationFrame(() => {
                contentDiv.style.maxHeight = contentDiv.scrollHeight + 'px';
              });

              setTimeout(() => {
                contentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 500);
              this.loadingSpinnerService.hideLoader();
            }
          );
      }
    }
  }
  getProcessedData() {
    this.locationData =  this.relationsGroupedByLocation.map((root) => ({
      root,
      telecomData: this.searchResultCardExpandTab2Service.processTelecom(
        root.location!.telecom!
      ),
    }));
  }
  ngOnDestroy(): void {
    this.titleService.setTitle(this.defaultTitle);
    this.searchResultData.unsubscribe();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  async addToGrandmaster(viewRef: any, data: any) {
    this.grandmaster.addChildrenToThisView(viewRef, data);
    // setTimeout(() => {
    //   // Now wait for a specific element that means "done"
    //   this.waitForHbsRender("grandmaster", '.rs-speciality', () => {
    //     // Place anything that must only happen after all Handlebars-driven elements are in the DOM here:
    //     this.isInitialSearh = false;
    //     // this.isSearchEnabled(); // or this.handleSearchClick(), etc.
    //   });
    // });
  }

  async getCareLoaDrJson() {
    const partialPromises = [
      this.searchService.fetchPartialFromDB('results-tabs', 'resultsTabs'),
    ];

    try {
      await Promise.all(partialPromises);

      // TODO: Remove once the API changes are ready to load the hbs files
      // this.searchResultData = this.searchResultService.getSearchResultJson(this.url).subscribe(response => {
        this.searchResultData = this.tenantConfigServiceV2.getTenantBluePrint({page_name: 'nls-result-page', tenant: CURRENT_TENNANT}).subscribe(response => {
               if(response == null) return;
              let res = atob(response);
        this.templateResponse = res;
        const template = Handlebars.compile(res);
        const renderedHtml = template({
          isPlanDropDownEnabled: !this.isPlanDropDownEnabled,
          planOptions: this.planOptions,
          specialtyOptions: this.specialtyOptions,
          genderOptions: this.genderOptions,
          languageOptions: this.languageOptions,
          searchCriteria: this.searchStateService.getSearchCriteria(),
          locationText: this.searchStateService.getSearchCriteria().Extra.locationText,
          providerSearchResults: this.providerCardDataArray,
          totalProviderSearchResults: this.providerSearchResults?.total,
          facilitySearchResults: this.facilityCardDataArray,
          totalFacilitySearchResults: this.facilitySearchResults?.total,
          aiSearchText: this.aiSearchText,
          isNLSearchEnabled: this.isNLSearchEnabled
        });
        console.log("console.log renderedHtml", renderedHtml);
        // this.customLabels =  JSON.parse(renderedHtml).customLabels
        this._data = JSON.parse(renderedHtml).componentsConfig;

        this.errorMessages.defaultErrorMessages = JSON.parse(renderedHtml).componentsConfig.errorMessages;
        // the below code is to hit api only for the mddoh if and only if the searchState.Query has sortBy, location and name.
        if(CURRENT_TENNANT === 'mddoh' &&
          Object.keys(this.searchState.Query).length === 3 &&
          this.searchState.Query.sortBy && // truthy check
          this.searchState.Query.location && // truthy check
          this.searchState.Query.name){
          setTimeout(() =>{ this.handleSearchClick() }, 1000);
        }

          this.buildWatcher.waitForBuildComplete().then(async resp => {
            this.filterSync.updateAllGroupCompsWithData();
            if(this.isInitialSearh){
              this.updateClearFiltersButtonVisibility();
            }
            this.isInitialSearh = false;
            this.isSearchEnabled();
          });
      });
      // setTimeout(() => {
      // await this.buildWatcher.waitForBuildComplete().then(async resp => {
      //   this.filterSync.updateAllGroupCompsWithData();
      //   if(this.isInitialSearh){
      //     this.updateClearFiltersButtonVisibility();
      //   }
      //   this.isInitialSearh = false;
      //   this.isSearchEnabled();
      // });
      //
      // }, 2000)


      // Process further UI changes
      let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
      let cfBottomUk = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_bottom");
      let cfMainUk = this.lobhelper.getDesiredChildUK(cfBottomUk, "cf_main");
      let resultTabsUk = this.lobhelper.getDesiredChildUK(cfMainUk, "results_tabs");
      this.providerTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_provider");
      this.facilityTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_facility");

      // Handle tab selection based on search results
      if (this.providerSearchResults?.total! == 0 && this.facilitySearchResults?.total! > 0) {
        this.currentTab = 'Group/Facility';
        setTimeout(() => {
          this.gmList.gmList[resultTabsUk].reference.changeTab(this.facilityTabUk, true);
        }, 700);
      } else {
        this.currentTab = 'Provider';
        setTimeout(() => {
          this.gmList.gmList[resultTabsUk].reference.changeTab(this.providerTabUk, true);
        }, 700);
      }

    } catch (error) {
      console.log("error while loading partials", error);
    }
  }


  //search-required groups
  updateDistanceDropdown(group: any){
    let sliderRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let distanceDDRef = this.gmList.gmList[group[1].uniqueKey].reference;
    if(sliderRef.data == distanceDDRef.data) return;
    if (sliderRef.data != distanceDDRef.data) {
      if (distanceDDRef.componentRef.componentType == Dropdown) {
        distanceDDRef.checkboxes.forEach((cb: Checkbox) => {
          cb.checked = false;
        })
        distanceDDRef.data = [sliderRef.data];
      } else {
        distanceDDRef.data = sliderRef.data;
      }
    }
    if (distanceDDRef.data[0]) {
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          location: {
            ...this.searchState.Query.location,
            distance: (Array.isArray(distanceDDRef.data) ? distanceDDRef.data[0] : distanceDDRef.data).toString()
          },
        },
      });
      if(!this.isInitialSearh) {
        this.isSearchEnabled();
      }
    }
  }

  handleInputChange(group: any) {
    let inputRef = this.gmList.gmList[group[0].uniqueKey].reference;

    if(this.searchState.Query.location?.distance == undefined){
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          location: {
            ...this.searchState.Query.location,
            distance: "25",
          },
        },
      });
    }
    if(inputRef.label === "Search Location"){
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          location: {
            ...this.searchState.Query.location,
            latitude: inputRef.data.geometry.location.lat() as unknown as string,
            longitude: inputRef.data.geometry.location.lng() as unknown as string,
          },
        },
        Extra: {
          ...this.searchState.Extra,
          locationText: inputRef.data.formatted_address,
        },
      });
    } else if (inputRef.label === "Provider / Group / Facility Name") {
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          name: inputRef.data,
        },
      });
    } else if (inputRef.label === "Specialty" || inputRef.label === "Provider Type / Specialty") {
      this.searchStateService.updateSearchCriteria({
        Query: {
          ...this.searchState.Query,
          specialtiesV2: inputRef.data,
        },
      });
    } else if (inputRef.label === "Select Your Plan") {
      const canSendProgramType = Array.isArray(inputRef.data) && inputRef.data[0]?.trim?.().length > 0;

      const { programType, ...restQuery } = this.searchState.Query;

      this.searchStateService.updateSearchCriteria({
        Query: {
          ...restQuery,
          ...(canSendProgramType && { programType: inputRef.data }),
        },
      });
    }
    this.isSearchEnabled();
  }

  // checking if all the required fields are filled
  isSearchEnabled() {
    if (this.isClearingFilters) return;
    const isFormValid =
      typeof this.searchState.Extra.locationText !== 'undefined' &&
      (
        (typeof this.searchState?.Query?.name !== 'undefined' &&
          this.searchState?.Query?.name?.trim() !== '' && this.searchState?.Query?.name?.length >= 2) ||
        (Array.isArray(this.searchState?.Query?.specialtiesV2) &&
          this.searchState?.Query?.specialtiesV2?.length > 0)
      );
    if(isFormValid){
      let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
      let cfBottomUk = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_bottom");
      let cfMainUk = this.lobhelper.getDesiredChildUK(cfBottomUk, "cf_main");
      this.overlay.destroyOverlay(cfMainUk, cfMainUk); // inorder to control the multiple loader overlay
      this.overlay.destroyOverlay(cfMainUk, cfMainUk); // inorder to control the multiple loader overlay
      setTimeout(() => {
        this.handleSearchClick();
      }, 1000);
    }
  }
  updateDistanceSlider(group: any){
    let distanceDDRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let sliderRef = this.gmList.gmList[group[1].uniqueKey].reference;
    sliderRef.data = distanceDDRef.data[0];
  }

  //search-filter groups
  selectedLanguage(group: any){
    this.languageDropdownUK = group[0].uniqueKey;
    this.languagePillUK = group[1].uniqueKey;
    let languagePillRef = this.gmList.gmList[this.languagePillUK].reference;
    let languageDropdownRef = this.gmList.gmList[this.languageDropdownUK].reference;
    let languageDropdownData = languageDropdownRef.data;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, language: languageDropdownData },
    });
    // let  areSame = this.lobhelper.compareArrays(languagePillRef.data, languageDropdownRef.selected);
    //
    // if (!areSame) {
    if(languageDropdownRef.selected.length != 0){
      languagePillRef.hide = false;
    }else{
      languagePillRef.hide = true;
    }
    //   // languagePillRef.data = languageDropdownData;
    // }
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  selectedGender(group: any){
    this.genderDropdownUK = group[0].uniqueKey;
    let genderDropdownRef = this.gmList.gmList[this.genderDropdownUK].reference;
    // this.genderPillUK = group[1].uniqueKey;
    // let genderPillRef = this.gmList.gmList[this.genderPillUK].reference;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, gender: genderDropdownRef.selected[0] },
    });
    // if(genderDropdownRef.selected.length != 0){
    //   genderPillRef.label = genderDropdownRef.selected[0];
    //   genderPillRef.hide = false;
    // }else{
    //   genderPillRef.hide = true;
    // }

    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  checkedAccepting(group: any){
    this.anpCheckboxUK = group[0].uniqueKey;
    let anpCheckboxRef = this.gmList.gmList[this.anpCheckboxUK].reference;
    // this.anpPillUk = group[1].uniqueKey;
    // let anpPillRef = this.gmList.gmList[this.anpPillUk].reference;
    const isChecked = anpCheckboxRef.checked ? true : undefined;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, isAcceptingNewPatient: isChecked}
    })
    // if(anpCheckboxRef.checked){
    //   anpPillRef.label = anpCheckboxRef.label;
    //   anpPillRef.hide = false;
    // }else{
    //   anpPillRef.hide = true;
    // }
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  acceptingDropdownUpdate(group: any) {
    this.acceptingDropdownUK = group[0].uniqueKey;
    let acceptingDropdownRef = this.gmList.gmList[this.acceptingDropdownUK].reference;
    // this.acceptingPillUK = group[1].uniqueKey;
    let acceptingPillRef = this.gmList.gmList[this.acceptingPillUK].reference;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, acceptingPatientsCodes: acceptingDropdownRef.data },
    });
    // if (acceptingDropdownRef.selected.length != 0){
    //   acceptingPillRef.label = acceptingDropdownRef.selected[0];
    //   acceptingPillRef.hide = false;
    // }
    // else {
    //   acceptingPillRef.hide = true;
    // }
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  checkedHandicap(group: any){
    this.handicapCheckboxUK = group[0].uniqueKey;
    let handicapCheckboxRef = this.gmList.gmList[this.handicapCheckboxUK].reference;
    // this.handicapPillUK = group[1].uniqueKey;
    // let handicapPillRef = this.gmList.gmList[this.handicapPillUK].reference;
    const isChecked = handicapCheckboxRef.checked ? true : undefined;
    this.searchStateService.updateSearchCriteria({
      Query: { ...this.searchState.Query, isHandicapAccessible: isChecked}
    })
    // if(handicapCheckboxRef.checked){
    //   handicapPillRef.label = handicapCheckboxRef.label;
    //   handicapPillRef.hide = false;
    // }else{
    //   handicapPillRef.hide = true;
    // }
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  checkedPCP(group: any){
    this.pcpCheckboxUK = group[0].uniqueKey;
    this.pcpPillUk = group[1]?.uniqueKey;
    let pcpCheckboxRef = this.gmList.gmList[this.pcpCheckboxUK].reference;
    // this.pcpPillUk = group[1].uniqueKey;
    // let pcpPillRef = this.gmList.gmList[this.pcpPillUk].reference;
    const isChecked = pcpCheckboxRef.checked ? true: undefined;
    if (CURRENT_TENNANT === 'champion') {
      const nextSpecialties = this.applyPcpSpecialtySelection(!!isChecked);
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: isChecked, specialtiesV2: nextSpecialties}
      });
    } else {
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: isChecked}
      });
    }
    // if(pcpCheckboxRef.checked){
    //   pcpPillRef.label = pcpCheckboxRef.label;
    //   pcpPillRef.hide = false;
    // }else{
    //   pcpPillRef.hide = true;
    // }
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  //close language pill groups and reset the language dropdown
  resetFilterLanguage(group: any){
    // let languageDropdownRef = this.gmList.gmList[this.languageDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.languagePillUK].reference;
    let languagePillGroupData = pillsGroupsRef.data;
    let langPillValues = this.getLanguageValuesFromDescriptions(this.languageOptions, pillsGroupsRef.data);
    // let areSame = this.lobhelper.compareArrays(languageDropdownRef.selected, languagePillGroupData);

    if(langPillValues.length == 0){
      this.searchState.Query.language = undefined;
      pillsGroupsRef.hide = true;
    }
    // if (!areSame) {
    //   languageDropdownRef.data = langPillValues;
    // }
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  getLanguageValuesFromDescriptions(options: option[], selectedDescriptions: string[]) {
    return options
      .filter(option => selectedDescriptions.includes(option.description))
      .map(option => option.value);
  }

  //close gender pill and reset the gender dropdown
  resetFilterGender(group: any){
    if ("gender" in this.searchState.Query) {
      this.searchState.Query.gender = undefined;
    }
    // let genderDropdownRef = this.gmList.gmList[this.genderDropdownUK].reference;
    // genderDropdownRef.data = [];
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  //close ANP pill and reset the ANP checkbox
  resetANPCheckbox(group: any){
    this.searchState.Query.isAcceptingNewPatient = undefined;
    // let handicapCheckboxRef = this.gmList.gmList[this.anpCheckboxUK].reference;
    // handicapCheckboxRef.checked = false;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  resetFilterAccepting(group: any){
    if ("acceptingPatientsCodes" in this.searchState.Query) {
      this.searchState.Query.acceptingPatientsCodes = undefined;
    }
    // let acceptingDropdownRef = this.gmList.gmList[this.acceptingDropdownUK].reference;
    // acceptingDropdownRef.data = [];
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  //close Handicap pill and reset the Handicap checkbox
  resetHandicapCheckbox(group: any){
    this.searchState.Query.isHandicapAccessible = undefined;
    // let anpCheckboxRef = this.gmList.gmList[this.handicapCheckboxUK].reference;
    // anpCheckboxRef.checked = false;
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }

  //close PCP pill and reset the PCP checkbox
  resetPCPCheckbox(group: any){
    this.searchState.Query.isPCP = undefined;
    const nextSpecialties = CURRENT_TENNANT === 'champion'
      ? this.applyPcpSpecialtySelection(false)
      : this.searchState.Query.specialtiesV2;
    if (this.pcpCheckboxUK && this.gmList.gmList[this.pcpCheckboxUK]?.reference) {
      this.gmList.gmList[this.pcpCheckboxUK].reference.checked = false;
    }
    this.hidePcpFilterPill();
    if (CURRENT_TENNANT === 'champion') {
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: undefined, specialtiesV2: nextSpecialties }
      });
    } else {
      this.searchStateService.updateSearchCriteria({
        Query: { ...this.searchState.Query, isPCP: undefined }
      });
    }
    this.isSearchEnabled();
    this.updateClearFiltersButtonVisibility();
  }
  // clear filter entires and pills
  clearFilters(group: any){
    this.isClearingFilters = true;
    let filterLanguageRef = this.gmList.gmList[group[1].uniqueKey].reference;
    if (this.languagePillUK && this.gmList.gmList[this.languagePillUK]?.reference) {
      this.gmList.gmList[this.languagePillUK].reference.data = [];
    }
    filterLanguageRef.data = [];
    let filterGenderRef = this.gmList.gmList[group[2].uniqueKey].reference;
    filterGenderRef.data = [];
    let filterANPRef = this.gmList.gmList[group[3].uniqueKey].reference;
    if(filterANPRef.label !== "New Patients"){
      filterANPRef.checked = false;
    }else{
      filterANPRef.data = undefined;
    }
    let filterHandicapRef =  this.gmList.gmList[group[4].uniqueKey].reference;
    filterHandicapRef.checked = false;
    let filterPCPRef = this.gmList.gmList[group[5].uniqueKey].reference;
    filterPCPRef.checked = false;
    this.hidePcpFilterPill();
    this.searchState.Query.language =undefined;
    if ("gender" in this.searchState.Query) {
      this.searchState.Query.gender = undefined;
    }
    this.searchState.Query.isAcceptingNewPatient = undefined;
    this.searchState.Query.isHandicapAccessible = undefined;
    if ("isPCP" in this.searchState.Query) {
      this.searchState.Query.isPCP = undefined;
    }
    if (CURRENT_TENNANT === 'champion') {
      this.searchState.Query.specialtiesV2 = this.applyPcpSpecialtySelection(false);
    }
    this.searchState.Query.acceptingPatientsCodes = undefined;
    setTimeout(() => {
      this.isClearingFilters = false;
      this.isSearchEnabled();
      this.updateClearFiltersButtonVisibility();
    }, 100);
  }
  updateClearFiltersButtonVisibility() {
    let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
    const cfTopUK = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_top");
    const cfFiltersUK = this.lobhelper.getDesiredChildUK(cfTopUK, "cf_filters");
    const cfFilterRef = this.gmList?.gmList?.[cfFiltersUK].reference;

    // Only check filters you care about
    const query = this.searchState?.Query || {};

    const hasLanguage = Array.isArray(query.language) && query.language.length > 0;
    const hasGender = 'gender' in query && !!query.gender;
    const hasANP = !!query.isAcceptingNewPatient;
    const hasHA = !!query.isHandicapAccessible;
    const hasPCP = 'isPCP' in query && !!query.isPCP;
    const hasAcceptingDD = !!query.acceptingPatientsCodes;

    const shouldShowClearButton = hasLanguage || hasGender || hasANP || hasHA || hasPCP || hasAcceptingDD;

    // Only show if one of these filters is active
    cfFilterRef.hide = !shouldShowClearButton;
  }

  private applyPcpSpecialtySelection(isChecked: boolean): string[] {
    const specialtyDropdownRef = this.getActiveSpecialtyDropdownRefForPcp();
    const nextValues = applyPcpSpecialtySelectionToDropdown({
      isChecked,
      dropdownRef: specialtyDropdownRef,
      currentValues: Array.isArray(this.searchState.Query.specialtiesV2)
        ? this.searchState.Query.specialtiesV2
        : [],
    });
    this.searchState.Query.specialtiesV2 = nextValues;
    return nextValues;
  }

  private getActiveSpecialtyDropdownRefForPcp(): any {
    const refs = this.getSpecialtyDropdownRefsByJsonId([
      'provider_or_speciality_dropdown',
      'provider_or_speciality_dropdown2',
      'provider_or_speciality_dropdown3',
      'provider_or_speciality_dropdown4',
      'providerOrSpecialityDropdown',
      'providerOrSpecialityDropdown2',
      'providerOrSpecialityDropdown3',
      'providerOrSpecialityDropdown4',
    ]);
    return getActiveVisibleEnabledRef(refs);
  }

  private getSpecialtyDropdownRefsByJsonId(dropdownIds: string[]): any[] {
    return getRefsByJsonId(this.gmList.gmList as any, dropdownIds);
  }

  private hidePcpFilterPill(): void {
    let pcpPillRef = this.pcpPillUk ? this.gmList.gmList[this.pcpPillUk]?.reference : undefined;
    if (!pcpPillRef) {
      pcpPillRef = this.getSpecialtyDropdownRefsByJsonId(['filter_pcp'])[0];
    }
    hideFilterPill(pcpPillRef);
  }


  /* print code */
  printReady(): boolean {
    if(this.currentTab === 'Provider') {
      return this.printProviderReady;
    }
    return this.printFacilityReady;
  }
  printResults(group: any) {
    if(!this.printReady()) return;
    //TODO: To be revised after configuration driven UI is implemented
    if (CURRENT_TENNANT == 'mddoh'){
      document.title = "Maryland Medicaid Provider Finder";
    }
    window.print();
  }
  buildPreface() {
    let folderPath = '../../assets/preface-' + CURRENT_TENNANT + '/'

    if(CURRENT_TENNANT === 'riverspring') [
      this.imgPaths = [
        folderPath + 'page1.png',
        folderPath + 'page2.png',
        folderPath + 'page3.png',
        folderPath + 'page4.png',
        folderPath + 'page5.png'
      ]
    ]
  }


  // handleSearchClick
  async handleSearchClick() {
    let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
    let cfBottomUk = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_bottom");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfBottomUk, "cf_main");
    const promise = await this.overlay.createOverlay(cfMainUk, true, cfMainUk);
    if (promise) {
      this.printProviderReady = false
      this.printFacilityReady = false
      this.printState = this.searchState;
      this.facilityPrintResults = {}
      this.providerPrintResults = {}
      this.currentPageProvider = 1;
      this.currentPageFacility = 1;
      const providerQueryParams: BasicProviderSearchQueryV2 = {
        ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
        skip: 0,
        limit: this.itemsPerPageProvider,
      };

      const facilityQueryParams: BasicOrganizationSearchQueryV2 = {
        ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
        skip: 0,
        limit: this.itemsPerPageFacility,
      };

      const providerPrintParams: BasicProviderSearchQuery = {
        ...omitBy(this.printState.Query, isNull),
        skip: 0,
        limit: 200,
      }

      const facilityPrintParams: BasicOrganizationSearchQuery = {
        ...omitBy(this.printState.Query, isNull),
        skip: 0,
        limit: 200,
      }

      forkJoin({
        providerResults:
          this.searchV2Service.getProviderResults(providerQueryParams),
        facilityResults:
          this.searchV2Service.getFacilityResults(facilityQueryParams),
      }).subscribe({
        next: (results) => {
          if (results && results.providerResults && results.facilityResults) {
            this.providerFilterSearchResults = results.providerResults;
            this.facilityFilterSearchResults = results.facilityResults;
          } else {
            this.providerFilterSearchResults = {};
            this.facilityFilterSearchResults = {};
          }
          if(this.providerFilterSearchResults?.total! == 0 && this.facilityFilterSearchResults?.total! > 0){
            this.currentTab = 'Group/Facility';
          } else{
            this.currentTab = 'Provider';
          }
          if (this.providerFilterSearchResults?.providers) {
            this.providerCardDataArray = {
              providers: this.mapSearchResults<AggregateRootOfPractitionerPractitionerRoleV2>(
                this.providerFilterSearchResults.providers,
                (item) => this.searchCardAdapter.adaptProvider(item)
              )
            };
          }
          if (this.facilityFilterSearchResults?.facilities) {
            this.facilityCardDataArray = {
              facilities: this.mapSearchResults<AggregateRootOfFacilityOrganizationAffiliationV2>(
                this.facilityFilterSearchResults.facilities,
                (item) => this.searchCardAdapter.adaptFacility(item)
              )
            };
          }
          this.updateResultTab();
        },
        error: (err) => {
          console.log('An error occurred:', err);
          this.overlay.destroyOverlay(cfMainUk, cfMainUk);
        }
      });

      forkJoin({
        providerPrint:
          this.searchV2Service.getProviderResults(providerPrintParams, true),
        facilityPrint:
          this.searchV2Service.getFacilityResults(facilityPrintParams, true),
      }).subscribe({
        next: (results) => {
          this.providerPrintResults = results.providerPrint as ProviderResponseOfPractitionerRoles;
          this.facilityPrintResults = results.facilityPrint as FacilityResponseOfOrgAffiliations;
          this.printProviderReady = true;
          this.printFacilityReady = true;
          setTimeout(() => {
            this.showHidePrintButton();
          }, 3000);
        },
        error: (err) => {
          console.log('An error occured:', err)
        }
      });
    }
  }

  updateResultTab(){
    let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
    let cfBottomUK = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_bottom");
    let cfMainUK = this.lobhelper.getDesiredChildUK(cfBottomUK, "cf_main");
    let resultsTabsUK = this.lobhelper.getDesiredChildUK(cfMainUK, "results_tabs");
    let resultsTabsRef = this.gmList.gmList[resultsTabsUK].reference;
    // let url = "../../assets/hbs_partials/results-tabs-partial.hbs"
    if(resultsTabsRef.children.length > 0) {
      resultsTabsRef.children.forEach(async (childUk: string) => {
        var childGm = this.gmList.gmList[childUk];
        await childGm.reference.clearForDestroy();
      });
    }
    // this.searchResultData = this.searchResultService.getSearchResultJson("../../assets/hbs_partials/results-tabs-partial.hbs").subscribe(response => {
    this.searchResultData = this.tenantConfigServiceV2.getTenantComponentBluePrint({page_name: 'results-tabs', tenant: CURRENT_TENNANT})
      .subscribe(response => {
        if(response.encodedTemplate == null) return;
        let res = atob(response.encodedTemplate);
        const template = Handlebars.compile(res);
        const renderedHtml = template({
          isPlanDropDownEnabled: !this.isPlanDropDownEnabled,
          planOptions: this.planOptions,
          specialtyOptions: this.specialtyOptions,
          genderOptions: this.genderOptions,
          languageOptions: this.languageOptions,
          searchCriteria: this.searchStateService.getSearchCriteria(),
          locationText: this.searchStateService.getSearchCriteria().Extra.locationText,
          providerSearchResults: this.providerCardDataArray,
          totalProviderSearchResults: this.providerFilterSearchResults?.total,
          facilitySearchResults: this.facilityCardDataArray,
          totalFacilitySearchResults: this.facilityFilterSearchResults?.total
        });
        // Wrap with curly braces to make it valid JSON
        const wrappedJson = `{${renderedHtml}}`;
        let data = JSON.parse(wrappedJson);

        if(resultsTabsRef.children.length > 0) {
          resultsTabsRef.children.forEach(async (childUk: string) => {
            var childGm = this.gmList.gmList[childUk];
            await childGm.reference.clearForDestroy();
          });
          resultsTabsRef.children = [];
          resultsTabsRef.tabs = [];
          resultsTabsRef.addChildrenToThisView(data);
        }else{
          resultsTabsRef.addChildrenToThisView(data);
        }
        let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
        let cfBottomUK = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_bottom");
        let cfMainUk = this.lobhelper.getDesiredChildUK(cfBottomUK, "cf_main");
        let resultTabsUk = this.lobhelper.getDesiredChildUK(cfMainUk, "results_tabs");
        if(this.providerFilterSearchResults?.total! == 0 && this.facilityFilterSearchResults?.total! > 0){
          this.currentTab = 'Group/Facility';
          setTimeout(() => {
            this.facilityTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_facility");
            this.gmList.gmList[resultTabsUk].reference.changeTab(this.facilityTabUk, true);
            this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          }, 700);
        } else{
          this.currentTab = 'Provider';
          setTimeout(() => {
            this.providerTabUk = this.lobhelper.getDesiredChildUK(resultTabsUk, "tab_provider");
            this.gmList.gmList[resultTabsUk].reference.changeTab(this.providerTabUk, true);
            this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          }, 700);
        }
      });
  }

  // Formating the value of the card data
  private formatValue(key: string, value: any): string {
    if (value !== "") {
      if (key === 'Phone' || key === 'Fax') {
        const regex = /\(?(\d{3})?\)?[-.\s]?(\d{3})?[-.\s]?(\d{4})?/;
        const match = value.match(regex);
        if (match) {
          return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
      }
    }
    return value;
  }
  getCardDataArray(cardData: any): { key: string; value: any }[] {
    if (!cardData?.list) {
      return [];
    }

    return Object.entries(cardData?.list).map(([key, value]) => ({
      key,
      value: this.formatValue(key, value) || undefined,
    }));
  }
  capitalizeEachWord(text: string): string {
    if (!text) return '';
    return text.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  truncateDistance(dist: string | undefined): string {
    if(dist) return parseFloat(dist).toFixed(2);
    return 'N/A';
  }


  // to Show or hide the print results button on each provider and facility tabs
  showHidePrintButton(){
    let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
    let resultBottomUk = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_bottom");
    let resultMainUk = this.lobhelper.getDesiredChildUK(resultBottomUk, "cf_main");
    this.printProviderResultBtnUk = this.lobhelper.getDesiredChildUK(resultMainUk, "print_provider_results_button");
    this.printFacilityResultBtnUk = this.lobhelper.getDesiredChildUK(resultMainUk, "print_facility_results_button");
    if(this.providerPrintResults.providers && (this.providerPrintResults.providers!.length > 0 || this.providerPrintResults.total == 0) && (this.currentTab == "Provider")){
      this.gmList.gmList[this.printProviderResultBtnUk].reference.hide = false;
      this.gmList.gmList[this.printFacilityResultBtnUk].reference.hide = true;
    }else if(this.facilityPrintResults.facilities && (this.facilityPrintResults.facilities!.length > 0 || this.facilityPrintResults.total == 0) && (this.currentTab == "Group/Facility")){
      this.gmList.gmList[this.printProviderResultBtnUk].reference.hide = true;
      this.gmList.gmList[this.printFacilityResultBtnUk].reference.hide = false;
    }else{
      this.gmList.gmList[this.printProviderResultBtnUk].reference.hide = false;
      this.gmList.gmList[this.printFacilityResultBtnUk].reference.hide = false;
    }
  }

  printDetailProvider(group: any){
    let printDetailProviderBtnRef = this.gmList.gmList[group[0].uniqueKey].reference;
    printDetailProviderBtnRef.disabled = true;
    printDetailProviderBtnRef.label = "Loading..."
    this.printService.getPrintPdfForSingleProvider(this.showMoreDetailsData as FacilityResponseOfMasteredLocationsV2).subscribe(pdfBlob => {
      const blobUrl = URL.createObjectURL(pdfBlob)
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = blobUrl
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow?.print();
      }
      printDetailProviderBtnRef.disabled = false;
      printDetailProviderBtnRef.label = "Print Provider"
    })
  }
  printDetailFacility(group: any){
    let printDetailFacilityBtnRef = this.gmList.gmList[group[0].uniqueKey].reference;
    printDetailFacilityBtnRef.disabled = true;
    printDetailFacilityBtnRef.label = "Loading..."
    this.printService.getPrintPdfForSingleFacility(this.showMoreDetailsData as ProviderResponseOfMasteredLocationsV2).subscribe(pdfBlob => {
      const blobUrl = URL.createObjectURL(pdfBlob)
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = blobUrl
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow?.print();
      }
      printDetailFacilityBtnRef.disabled = false;
      printDetailFacilityBtnRef.label = "Print Group/Facility"
    })
  }

  // find the first non-disabled (0/empty) tab and focus it
  focusResultsTab(group: any){
    var tabsGM = this.gmList.gmList[group[1].uniqueKey];
    // check if there's a tab that isn't disabled - this means there's at least 1 search result between provider/facility!
    var firstNotDisabledTab = tabsGM.elementRef?.querySelector(".tabs .tab:not([disabled])") as HTMLElement;
    // focus on the first not-disabled tab
    if (firstNotDisabledTab){
      firstNotDisabledTab.focus();
    }
    // if there is none, that means there were no search results, so jump to search criteria instead
    else {
      var editCriteriaButtonGM = this.gmList.gmList[group[2].uniqueKey];
      if (window.getComputedStyle(editCriteriaButtonGM.elementRef!).getPropertyValue('display') !== "none"){
        editCriteriaButtonGM.elementRef?.querySelector("button")!.click();
      }
      setTimeout(() => {
        var requiredSearchContainerGM = this.gmList.gmList[group[3].uniqueKey];
        // check first if there's a plan dropdown and if so, focus that
        var planDropdown = requiredSearchContainerGM.elementRef?.querySelector(".rs-plan") as HTMLElement;
        if (planDropdown){
          planDropdown.focus();
        }
        // no plan dropdown, so focus location instead
        else {
          var locationGAF = requiredSearchContainerGM.elementRef?.querySelector(".rs-location") as HTMLElement;
          locationGAF.focus();
        }
      });
    }
  }

  async pagination(group: any) {
    let outerContainerRef = this.lobhelper.getDesiredChildUK("1", "main_outer_container");
    let cfBottomUk = this.lobhelper.getDesiredChildUK(outerContainerRef, "cf_bottom");
    let cfMainUk = this.lobhelper.getDesiredChildUK(cfBottomUk, "cf_main");
    const promise = await  this.overlay.createOverlay(cfMainUk, true, cfMainUk);
    if (promise) {
      let parentContainerRef = this.gmList.gmList[group[0].parentToChangePage].reference;

      if (parentContainerRef.label === 'provider results pagination') {
        let tabParentUk = this.lobhelper.getDesiredParentUK(group[0].parentToChangePage, "tab_provider");
        let tabProviderCardContainerUk = this.lobhelper.getDesiredChildUK(tabParentUk, "tab_provider_results");
        let tabProviderCardContainerRef = this.gmList.gmList[tabProviderCardContainerUk].reference;
        this.itemsPerPageProvider = group[0].perPage;
        let currentPage = group[0].pageClicked;
        const skip = (currentPage - 1) * group[0].perPage;

        const queryParams = {
          ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
          skip: skip,
          limit: group[0].perPage,
        };

        this.searchV2Service.getProviderResults(queryParams).subscribe({
          next: (results) => {
            this.providerSearchResults = results;
            if (this.providerSearchResults?.providers) {
              this.providerCardDataArray = {
                providers: this.mapSearchResults<AggregateRootOfPractitionerPractitionerRoleV2>(
                  this.providerSearchResults.providers,
                  (item) => this.searchCardAdapter.adaptProvider(item)
                )
              };
              // this.searchResultService.getSearchResultJson("../../assets/hbs_partials/provider-card-partial.hbs").subscribe(response => {
              this.searchResultData = this.tenantConfigServiceV2.getTenantComponentBluePrint({page_name: 'provider-card', tenant: CURRENT_TENNANT})
                .subscribe(response => {
                  if(response.encodedTemplate == null) return;
                  let res = atob(response.encodedTemplate);
                  const template = Handlebars.compile(res);
                  const renderedHtml = template({
                    isPlanDropDownEnabled: !this.isPlanDropDownEnabled,
                    planOptions: this.planOptions,
                    specialtyOptions: this.specialtyOptions,
                    genderOptions: this.genderOptions,
                    languageOptions: this.languageOptions,
                    searchCriteria: this.searchStateService.getSearchCriteria(),
                    locationText: this.searchStateService.getSearchCriteria().Extra.locationText,
                    providerSearchResults: this.providerCardDataArray,
                    totalProviderSearchResults: this.providerFilterSearchResults?.total,
                    facilitySearchResults: this.facilityCardDataArray,
                    totalFacilitySearchResults: this.facilityFilterSearchResults?.total
                  });
                  let data = JSON.parse(renderedHtml);
                  if (tabProviderCardContainerRef.children.length > 0) {
                    tabProviderCardContainerRef.children.forEach(async (childUk: string) => {
                      var childGm = this.gmList.gmList[childUk];
                      await childGm.reference.clearForDestroy();
                    });
                    tabProviderCardContainerRef.children = [];
                    // resultsTabsRef.tabs = [];
                    tabProviderCardContainerRef.addChildrenToThisView(data);
                  }
                })
            }

          },
          error: (err) => {
            console.error('Error while fetching provider results:', err);
            if (err.status === 500) {
              // handle 500 Internal Server Error

            } else {
              // handle other HTTP errors

            }

            // Optionally, close overlay or clean up
            // this.overlay.destroyOverlay(cfMainUk, cfMainUk);
          },
          complete: () => {
            // this.loadingSpinnerService.hideLoader();
            // this.isLoading = false;
            setTimeout(() => {
              this.overlay.destroyOverlay(cfMainUk, cfMainUk);
            }, 700);
          }
        });

      } else {
        let tabParentUk = this.lobhelper.getDesiredParentUK(group[0].parentToChangePage, "tab_facility");
        let tabFacilityCardContainerUk = this.lobhelper.getDesiredChildUK(tabParentUk, "tab_facility_container");
        let tabFacilityCardContainerRef = this.gmList.gmList[tabFacilityCardContainerUk].reference;
        this.itemsPerPageFacility = group[0].pageSize;
        let currentPage = group[0].pageClicked;
        const skip = (currentPage - 1) * this.itemsPerPageFacility;

        const queryParams = {
          ...omitBy(this.searchStateService.getSearchCriteria().Query, isNull),
          skip: skip,
          limit: this.itemsPerPageFacility,
        };

        this.searchV2Service.getFacilityResults(queryParams).subscribe({
          next: (results) => {
            this.facilitySearchResults = results;
            if (this.facilitySearchResults?.facilities) {
              this.facilityCardDataArray = {
                facilities: this.mapSearchResults<AggregateRootOfFacilityOrganizationAffiliationV2>(
                  this.facilitySearchResults.facilities,
                  (item) => this.searchCardAdapter.adaptFacility(item)
                )
              };

              // this.searchResultService.getSearchResultJson("../../assets/hbs_partials/facility-card-partial.hbs").subscribe(response => {
              this.searchResultData = this.tenantConfigServiceV2.getTenantComponentBluePrint({page_name: 'facility-card', tenant: CURRENT_TENNANT})
                .subscribe(response => {
                  if(response.encodedTemplate == null) return;
                  let res = atob(response.encodedTemplate);
                  const template = Handlebars.compile(res);
                  const renderedHtml = template({
                    facilitySearchResults: this.facilityCardDataArray
                  });
                  let data = JSON.parse(renderedHtml);
                  if (tabFacilityCardContainerRef.children.length > 0) {
                    tabFacilityCardContainerRef.children.forEach(async (childUk: string) => {
                      var childGm = this.gmList.gmList[childUk];
                      await childGm.reference.clearForDestroy();
                    });
                    tabFacilityCardContainerRef.children = [];
                    // resultsTabsRef.tabs = [];
                    tabFacilityCardContainerRef.addChildrenToThisView(data);
                  }
                })
            }

          },
          complete: () => {
            // this.loadingSpinnerService.hideLoader();
            // this.isLoading = false;
            setTimeout(() => {
              this.overlay.destroyOverlay(cfMainUk, cfMainUk);
            }, 700);
          },
        });
      }
    }
  }

}
